import { Injectable } from '@angular/core';

/**
 * Service for building PDF URLs for cotizaciones
 * Handles data extraction and URL construction for cotizacion-pdf.php
 */
@Injectable()
export class PdfCotizacionBuilderService {

    private readonly PDF_BASE_URL = 'https://operacion.trosten.com/pdf-service/cotizacion-pdf.php';

    constructor() { }

    /**
     * Extracts combinaciones data from servicio for PDF display
     * Converts cost/price data to formatted array
     *
     * @param servicio Service object with costoCombinaciones and precioCombinaciones
     * @returns Array of combinacion objects with tipo, numero, and precio formatted
     */
    extractCombinacionesData(servicio: any): any[] {
        const combinaciones = [];

        for (const keyUnidad in servicio.costoCombinaciones) {
            if (servicio.costoCombinaciones.hasOwnProperty(keyUnidad)) {
                const unidad = servicio.costoCombinaciones[keyUnidad];
                for (const indiceUnidad in unidad) {
                    if (unidad.hasOwnProperty(indiceUnidad)) {
                        const res = unidad[indiceUnidad];

                        const precio = Math.round(servicio['precioCombinaciones'][keyUnidad]);
                        const tipo_unidad = indiceUnidad;
                        const num_unidades = res.numeroDeUnidades + " Unidad(es) ";

                        combinaciones.push({
                            t: indiceUnidad,
                            n: num_unidades,
                            p: 'Unidad ' + indiceUnidad + ": $" + (precio).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                        });
                    }
                }
            }
        }

        return combinaciones;
    }

    /**
     * Builds complete PDF URL for cotizacion
     *
     * @param params Object with all required PDF parameters
     * @returns Complete PDF URL with encoded parameters
     */
    buildCotizacionPdfUrl(params: {
        idTrosten: string;
        clienteNombre: string;
        origenAlias: string;
        destinoAlias: string;
        inicioDeServicio: number;
        finDeServicio: number;
        indicacionesEspeciales: string;
        combinaciones: any[];
        conceptosAdicionales: any;
        tipoDeVenta: string;
    }): string {

        const { idTrosten, clienteNombre, origenAlias, destinoAlias, inicioDeServicio, finDeServicio, indicacionesEspeciales, combinaciones, conceptosAdicionales, tipoDeVenta } = params;

        const url = this.PDF_BASE_URL +
            "?id=" + idTrosten +
            "&cliente=" + clienteNombre +
            "&o=" + origenAlias +
            "&d=" + destinoAlias +
            "&i=" + inicioDeServicio +
            "&indEsp=" + indicacionesEspeciales +
            "&f=" + finDeServicio +
            "&c=" + JSON.stringify(combinaciones) +
            "&cA=" + JSON.stringify(conceptosAdicionales) +
            "&tv=" + tipoDeVenta;

        return url;
    }

    /**
     * Builds PDF URL from cotizacion and cliente objects
     * Main method that combines extraction and URL building
     *
     * @param cotizacion Cotizacion object with servicios
     * @param cliente Cliente object with nombre
     * @returns Complete PDF URL
     */
    buildPdfFromCotizacion(cotizacion: any, cliente: any): string {
        const servicios_arr = [];
        for (const idServicio in cotizacion.servicios) {
            servicios_arr.push(cotizacion.servicios[idServicio]);
        }

        const servicio = servicios_arr[0];
        const combinaciones = this.extractCombinacionesData(servicio);
        const conceptosAdicionales = servicio.conceptosAdicionales || [];

        return this.buildCotizacionPdfUrl({
            idTrosten: cotizacion.idTrosten,
            clienteNombre: cliente.nombre,
            origenAlias: servicio.origen.alias,
            destinoAlias: servicio.destino.alias,
            inicioDeServicio: servicio.itinerario.inicioDeServicio,
            finDeServicio: servicio.itinerario.finDeServicio,
            indicacionesEspeciales: servicio.indicacionesEspeciales,
            combinaciones: combinaciones,
            conceptosAdicionales: conceptosAdicionales,
            tipoDeVenta: cotizacion.tipoDeVenta
        });
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/helpers/pdf-cotizacion-builder.service.ts